module.exports = __webpack_public_path__ + "img/DPF_logo.a726107d.png";